import * as Yup from 'yup';

export class CreateBuildingValidator {
  public get schema() {
    return Yup.object().shape({
      name: Yup.string().required('Informe o nome do prédio'),
      areaId: Yup.number()
        .typeError('Informe a área')
        .required('Informe a área'),
      condition: Yup.string()
        .oneOf(['INFLAMÁVEL', 'REFRIGERADO', 'QUÍMICO', null])
        .nullable()
        .transform((value) => value || null),
    });
  }
}
